import axios from 'axios'
import envConfigs from '../configs/envConfigs'
import { TIMEOUT_TIME } from '../constants'
import { portalAuthHttpClient } from '../utils/HttpRequestUtils'
import {
  getQuoteRequestBody,
  getSaveBookingRequestBody,
  getSaveQuoteRequest,
  getcheckShipmentIsBigOrOHGRequest,
  getFileList,
  getUpdateBookingRequestData,
  getValidateUpdateBookingRequest,
  getSavePetUpdateBookingRequest,
  getSaveDGUpdateBookingRequest,
  getSaveLivePetsBookingRequest,
  getSaveDGSaveBookingRequest,
  buildRussiaAttachmentRequestData,
} from '../utils/RequestBodyUtils'
import { v4 as uuidv4 } from 'uuid'

export const getPromoCodeResponse = async (searchFormData) => {
  const data = getQuoteRequestBody(searchFormData)
  const url = `${envConfigs.baseUrl}${envConfigs.getValidatePromoCodeUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}


export const getValidateSpotRateResponse = async (searchFormData) => {
  const data = getQuoteRequestBody(searchFormData)
  const url = `${envConfigs.baseUrl}${envConfigs.getValidateSpotRateUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const getQuoteResponse = async (searchFormData) => {
  const data = getQuoteRequestBody(searchFormData, true)
  const url = `${envConfigs.apimUrl}${envConfigs.getNewQuoteFlightList}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const getSaveBookingResponse = async (
  searchFormData,
  selectedFlight,
  spotRatePayload,
  awbNumber
) => {
  let data = await getSaveBookingRequestBody(
    searchFormData,
    selectedFlight,
    spotRatePayload,
    awbNumber
  )
  const url = `${envConfigs.apimUrl}${envConfigs.createBookingUrl}`
  const response = await portalAuthHttpClient.post(url, data)

  //let petFiles = await getFileList();

  /*if (response?.data?.bookingResponseDetails) {
      try {
          //savePetFileList(`607-${response.data.bookingResponseDetails.masterDocumentNumber}`, petFiles)
          savePetFileList(`${response.data.bookingResponseDetails.shipmentPrefix}-${response.data.bookingResponseDetails.masterDocumentNumber}`, petFiles)
      }
      catch {
          console.log("File upload Failed")
      }
  }*/

  return response.data.responseDetails
}

export const savePetFileList = async (
  awbNumber,
  petFiles,
) => {

  const data = {
    multipartFiles: petFiles,
    awbNumber: awbNumber,
  }
  const url = `${envConfigs.baseUrl}${'/booking/bookingdetails/saveAttachments'}`
  const response = await portalAuthHttpClient.post(url, data)

}

export const updateBooking = async (
  searchFormData,
  selectedFlight,
  awbNumber,
  spotRatePayload
) => {
  let data = getUpdateBookingRequestData(
    searchFormData,
    selectedFlight,
    spotRatePayload,
    awbNumber
  )
  const url = `${envConfigs.apimUrl}${envConfigs.doUpdateBooking}`
  const response = await portalAuthHttpClient.post(url, data)

  // Keep legacy updateStatusDetails for existing UI code while supporting new updateStatus
  const rawResponse = response.data
  const responseDetails = rawResponse?.responseDetails || {}

  const normalizedResponseDetails = {
    ...responseDetails,
    updateStatusDetails: responseDetails.updateStatusDetails || {
      bookingValidationStatus: responseDetails.updateStatus?.status || 'F',
      validationFailureDescription: responseDetails.updateStatus?.description || null,
    },
  }

  return {
    ...rawResponse,
    responseDetails: normalizedResponseDetails,
  }
}

export const validateUpdateBooking = async (
  formData
) => {
  let data = getValidateUpdateBookingRequest(
    formData
  )
  const url = `${envConfigs.apimUrl}${envConfigs.doValidateUpdateBooking}`
  const response = await portalAuthHttpClient.post(url, data)

  // Normalize new API response to the shape expected by existing UI code
  const rawResponse = response.data
  const responseDetails = rawResponse?.responseDetails || {}

  // Keep booking details as-is since API response keys already match existing UI usage
  const bookingDetails = responseDetails.validateBookingResponse?.validateBookingDetails || null

  const normalizedDetails = {
    requestID: responseDetails.requestID,
    referenceId: responseDetails.referenceId,
    errorDetails: responseDetails.errorDetails,
    newFlightsList: responseDetails.newFlightsList,

    // Map new validationStatus to legacy updateStatusDetails for existing UI code
    updateStatusDetails: {
      bookingValidationStatus: responseDetails.validationStatus?.status || 'F',
      validationFailureDescription: responseDetails.validationStatus?.description || null,
    },

    // Map new validateBookingResponse to legacy validateBookingResponseDto for existing UI code
    validateBookingResponseDto: bookingDetails
      ? { validateBookingDetails: bookingDetails }
      : null,
  }

  return {
    ...rawResponse,
    responseDetails: normalizedDetails,
  }
}

export const savePetDetailsForUpdate = async (
  formData
) => {
  let data = getSavePetUpdateBookingRequest(
    formData
  )
  const url = `${envConfigs.baseUrl}${envConfigs.doUpdateCageDetails}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const saveDGAttachementsForUpdate = async (
  formData
) => {
  let data = getSaveDGUpdateBookingRequest(
    formData
  )
  const url = `${envConfigs.baseUrl}${envConfigs.doUpdateDGDetails}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}


export const saveLivePetsForSaveBooking = async (
  formData,
  awbNumber
) => {
  let data = getSaveLivePetsBookingRequest(formData, awbNumber)
  const url = `${envConfigs.baseUrl}${envConfigs.saveLivePetsUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const saveDGAttachementsForSaveBooking = async (
  formData,
  awbNumber
) => {
  let data = getSaveDGSaveBookingRequest(
    formData,
    awbNumber
  )
  const url = `${envConfigs.baseUrl}${envConfigs.saveDGDetails}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}


export const validateBooking = async (
  searchFormData,
  selectedFlight,
  awbNumber,

) => {
  let data = getSaveBookingRequestBody(
    searchFormData,
    selectedFlight,
    null,
    awbNumber
  )
  if (data) {
    data.bookingDetails.quotationID = uuidv4()
  }
  const url = `${envConfigs.baseUrl}${envConfigs.validateBookingUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const saveQuote = async (
  searchFormData,
  selectedFlight,
  quotationDetails

) => {
  let data = getSaveQuoteRequest(searchFormData, selectedFlight, quotationDetails)
  const url = `${envConfigs.baseUrl}${envConfigs.saveQuoteUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const findQuote = async (data) => {
  const url = `${envConfigs.baseUrl}${envConfigs.findQuoteUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const deleteQuote = async (data) => {
  const url = `${envConfigs.baseUrl}${envConfigs.deleteQuoteUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const listQuotes = async (data) => {
  const url = `${envConfigs.baseUrl}${envConfigs.listQuoteUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const checkShipmentIsBigOrOHG = async (searchFormData) => {
  let data = getcheckShipmentIsBigOrOHGRequest(searchFormData)

  const url = `${envConfigs.baseUrl}${envConfigs.checkBigOrOHGUrl}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const getValidationRule = async (captureType) => {
  const url = `${envConfigs.baseUrl}${envConfigs.getValidationRuleUrl}/${captureType}`
  const response = await portalAuthHttpClient.get(url)
  return response.data
}

export const getRestrictedList = async (data) => {
  const url = `${envConfigs.baseUrl}${envConfigs.getBookingRestriction}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const uploadRussiaAttachment = async (data) => {
  const url = `${envConfigs.baseUrl}${envConfigs.uploadRussiaAttachment}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}

export const saveRussiaAttachementsForSaveBooking = async (
  formData,
  awbNumber,
  ubrNumber
) => {
  const requestData = buildRussiaAttachmentRequestData(formData, awbNumber, ubrNumber);
  const url = `${envConfigs.baseUrl}${envConfigs.saveRussiaAttachments}`
  const response = await portalAuthHttpClient.post(url, requestData)
  return response.data
}


export const deleteRussiaAttachment = async (data) => {
  const url = `${envConfigs.baseUrl}${envConfigs.deleteRussiaAttachment}`
  const response = await portalAuthHttpClient.post(url, data)
  return response.data
}


